import { render, staticRenderFns } from "./ReceiptComboProduct.vue?vue&type=template&id=a1b48f70&scoped=true&"
import script from "./ReceiptComboProduct.vue?vue&type=script&lang=js&"
export * from "./ReceiptComboProduct.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptComboProduct.vue?vue&type=style&index=0&id=a1b48f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b48f70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCol,VIcon,VRadio,VRadioGroup,VRow,VSimpleTable})
